export default __webpack_public_path__ + "static/media/chevron.517fbdb6.svg";